(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("../../utils/assert"));
	else if(typeof define === 'function' && define.amd)
		define(["../../utils/assert"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("../../utils/assert")) : factory(root["../../utils/assert"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return 